import React, { useState, useEffect, useContext } from 'react';
import {
  Grid
} from '@mui/material';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import AnnouncementIcon from '@mui/icons-material/Announcement';
import { createStyles, makeStyles } from '@mui/styles';


const useStyles = makeStyles((theme) =>
  createStyles({
    root: {
      flexGrow: 1,
    },
    menuButton: {
      marginRight: theme.spacing(2),
    },
    loading: {
      textAlign: 'center',
    },
    notice: {
      backgroundColor: theme.palette.primary.main,
      color: '#fff'
    },

  }),
);

export default function UnknownFR(props) {
    const classes = useStyles();

    return (
      <div class={classes.UnknownFR}>
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <Card className={classes.notice} variant="outlined" color="secondary">
              <CardContent>
                <AnnouncementIcon color="secondary" fontSize="large" style={{ float: 'left' }} />
                <div style={{ float: 'left', marginTop: -9, paddingLeft: 10 }} dangerouslySetInnerHTML={{ __html: props.text }}></div>
              </CardContent>
            </Card>
          </Grid>
        </Grid>
      </div>
    )
  }